/** Karten: Routen-Heatmap, Explorer-Kacheln, Kartenbeschriftungen. */
export default {
  title: 'Karten',
  kicker: {
    one: '{count} Aktivität mit GPS · {dist} · Startorte ausgeblendet',
    other: '{count} Aktivitäten mit GPS · {dist} · Startorte ausgeblendet',
  },
  year: 'Jahr',
  all: 'Alle',
  routesFailed: 'Routen nicht geladen: {error}',
  tilesFailed: 'Kacheln nicht geladen: {error}',
  explorerAria: 'Explorer-Tiles',
  tilesLoading: 'Kacheln werden berechnet …',
  heatmapAria: 'Routen-Heatmap',
  routesLoading: 'Routen werden geladen …',
  perSport: 'Je Sportart',
  privacy:
    'Um Start und Ziel jeder Route ist ein Kreis von {m} m ausgeschnitten – auch wo die Route später wieder vorbeikommt. So lässt sich aus der Überlagerung keine Adresse ablesen. Tippen auf eine Linie öffnet die Aktivität.',
  layer: { aria: 'Kartenebene', routes: 'Routen', tiles: 'Kacheln' },
  tiles: {
    title: 'Explorer-Tiles',
    count: { one: '{count} Kachel', other: '{count} Kacheln' },
    square: 'Größtes Quadrat',
    cluster: 'Größter Cluster',
    newIn: 'Neu im {month}',
    histAria: 'Neue Kacheln je Monat, letzte 12 Monate: {list}',
    visited: 'besucht',
    newInLegend: 'neu im {month}',
    squareLegend: 'Quadrat',
    privacy:
      'Kacheln (Zoom {zoom}, gut 1 km Kante) aus {count} Aktivitäten mit vollem GPS-Verlauf. Kacheln, die eine Route nur im Umkreis von {radius} m um Start oder Ziel berührt, zählen mit, werden aber nicht gezeigt. Wie oft du in einer Kachel warst, steht nirgends.',
  },
  mapAria: {
    route: 'Karte mit der Route dieser Aktivität',
    heat: 'Karte mit {count} Routen übereinander',
    tiles: 'Karte mit {count} besuchten Kacheln',
  },
};
